import { ArrowBackIosNewOutlined } from '@mui/icons-material'
import { Button, ButtonProps } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

interface ExtraButtonProps {
  href?: string
  external?: boolean
  children?: React.ReactNode
}

const PureButton: React.FC<ExtraButtonProps & ButtonProps> = ({
  onClick,
  href,
  ...props
}) => {
  return (
    <Button
      color='primary'
      variant='contained'
      onClick={onClick}
      {...props}
    >
      {props.children}
    </Button>
  )
}

const CustomButton: React.FC<ExtraButtonProps & ButtonProps> = ({
  href,
  external,
  ...props
}) => {
  if (href == null) {
    return (
      <PureButton
        {...props}
      />
    )
  }

  if (external === true) {
    return (
      <a href={href} target='_blank' rel='noreferrer'>
        <PureButton
          {...props}
        />
      </a>
    )
  }

  return (
    <Link to={href}>
      <PureButton
        {...props}
      />
    </Link>
  )
}

export const CustomBackButton: React.FC<ExtraButtonProps & ButtonProps> = (props) => {
  return (
    <CustomButton
      variant='outlined'
      startIcon={
        <ArrowBackIosNewOutlined
          sx={{
            width: '15px',
            height: '15px',
            color: 'primary.main',
            marginRight: '8px'
          }}
        />
      }
      {...props}
    />
  )
}

export default CustomButton
